import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { DealEstimationHistoryContext } from '~/models/DealEstimationHistory';

const paths = {
  index: '/vendors/deals/:deal_id/deal_estimation_histories'
};
type TIndex = (
  dealId: number | null
) => SwrReturnType<DealEstimationHistoryContext>;
type ReturnType = {
  index: TIndex;
};

export const useDealEstimationHistories = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    const { data, mutate, isLoading, error } =
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useSWR<DealEstimationHistoryContext>(
        dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
      );
    return {
      data: data ?? null,
      mutate,
      isLoading,
      error
    };
  };
  return { index };
};
